export const navItems = [

  { title: 'Learning', disabled: true },

  {
    title: '▸ How the Web Works',
    path: '/web-fundamentals',
  },  

  {
    title: '▸ JavaScript & Browser Internals',
    path: '/javascript-browser',
  },

  {
    title: '▸ Web Vulnerabilities',
    path: '/web-vulnerabilites',
  },

  { title: 'Discovery / Investigation', disabled: true },

  {
    title: '▸ Information Gathering',
    path: '/information-gathering',
  },

  { title: 'Practical / Hands-on', disabled: true },

  {
    title: '▸ Web Security Methodology',
    path: '/web-security-methodology',
  },

  {
    title: '▸ Security Testing Tools',
    path: '/security-tools',
  },

  { title: 'Other', disabled: true },

  { title: 'Home', path: '/' },

  { title: 'About', path: '/about' },

  { title: 'Contact', path: '/contact' },
];